var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1708,
    height: 854,
    viewBox: "0 0 1708 854",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1706 854C1706 1324.55 1324.55 1706 854 1706C383.453 1706 2 1324.55 2 854C2 383.453 383.453 2 854 2C1324.55 2 1706 383.453 1706 854ZM1708 854C1708 1325.65 1325.65 1708 854 1708C382.349 1708 0 1325.65 0 854C0 382.349 382.349 0 854 0C1325.65 0 1708 382.349 1708 854ZM1503.01 854C1503.01 1212.44 1212.44 1503.01 853.999 1503.01C495.558 1503.01 204.984 1212.44 204.984 854C204.984 495.559 495.558 204.985 853.999 204.985C1212.44 204.985 1503.01 495.559 1503.01 854ZM1505.01 854C1505.01 1213.55 1213.54 1505.01 853.999 1505.01C494.454 1505.01 202.984 1213.55 202.984 854C202.984 494.454 494.454 202.985 853.999 202.985C1213.54 202.985 1505.01 494.454 1505.01 854ZM854 1336.6C1120.53 1336.6 1336.6 1120.53 1336.6 854C1336.6 587.466 1120.53 371.396 854 371.396C587.466 371.396 371.396 587.466 371.396 854C371.396 1120.53 587.466 1336.6 854 1336.6ZM854 1338.6C1121.64 1338.6 1338.6 1121.64 1338.6 854C1338.6 586.361 1121.64 369.396 854 369.396C586.361 369.396 369.396 586.361 369.396 854C369.396 1121.64 586.361 1338.6 854 1338.6ZM1184.82 854C1184.82 1036.71 1036.71 1184.82 854 1184.82C671.292 1184.82 523.178 1036.71 523.178 854C523.178 671.292 671.292 523.178 854 523.178C1036.71 523.178 1184.82 671.292 1184.82 854ZM1186.82 854C1186.82 1037.81 1037.81 1186.82 854 1186.82C670.187 1186.82 521.178 1037.81 521.178 854C521.178 670.188 670.187 521.178 854 521.178C1037.81 521.178 1186.82 670.188 1186.82 854Z",
    fill: "url(#paint0_radial_1425_1261)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1425_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(854 575.5) rotate(90) scale(642.283 1227.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBackground);
export default __webpack_public_path__ + "static/media/HeaderBackground.eac2f47f24f5c7ee5f27a8598ae5afb4.svg";
export { ForwardRef as ReactComponent };